import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material'

import { AppContext } from '/providers/app-context'

const ActivePassLimitErrorDialog = ({ open, setOpen, error }) => {

  const { client } = useContext(AppContext)

  const navigate = useNavigate()

  const close = (e, reason) => {
    if (reason && reason === "backdropClick")
      return
    setOpen(false)
  }

  if (open) {
    if (error.name === 'ActivePassLimitError') return (
      <Dialog
        open={open}
        onClose={close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {error?.message}
        </DialogTitle>

        <DialogContent>
          <div className='mb-5 font-semibold'>You have used all of your active pass allowance of the {client.tariff_tier} tier tariff</div>
          <div className='mb-5'>You are using {error?.value.currentActivePasses} active passes out of an allowance of {error?.value.permittedActivePasses}</div>

          <div>In order to issue further passes you will need to change your tariff or delete some unwanted passes</div>
        </DialogContent>

        <DialogActions>
          <div className="flex flex-row justify-between w-full p-5">
            <div className='flex flex-row gap-5'>
              <Button variant="outlined" onClick={() => navigate("/billing/")}>Go to Billing</Button>
              <Button variant="outlined" onClick={() => navigate("/active-passes/")}>Review Passes</Button>
            </div>

            <Button variant="contained" onClick={close} autoFocus >Close</Button>
          </div>
        </DialogActions>
      </Dialog>
    )

    return (
      <Dialog
        open={open}
        onClose={close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Error making pass
        </DialogTitle>

        <DialogContent>
          {error?.name ?? error}
        </DialogContent>

        <DialogActions>
          <div className="flex flex-row justify-end w-full p-5">
            <Button variant="contained" onClick={close} autoFocus >Close</Button>
          </div>
        </DialogActions>
      </Dialog>
    )
  }

}

export default ActivePassLimitErrorDialog